import { render, staticRenderFns } from "./algorithm.vue?vue&type=template&id=0202e2b7&"
import script from "./algorithm.vue?vue&type=script&lang=js&"
export * from "./algorithm.vue?vue&type=script&lang=js&"
import style0 from "./algorithm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports